// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__YyDYO","right":"Footer_right__2fXE4","buttons":"Footer_buttons__Tb1kT"};